import Markdown from "react-markdown";
import "github-markdown-css";
import remarkGfm from "remark-gfm";

const LinkRenderer = ({ ...props }) => (
  <a
    href={props.href}
    target="_blank"
    rel="noopener noreferrer"
    className="underline"
  >
    {props.children}
  </a>
);

const ImageRenderer = ({ ...props }) => (
  <img
    {...props}
    src={props.src}
    alt={props.alt ?? "challenges image"}
    className="max-w-96 rounded-md mt-4"
    style={{
      backgroundColor: "inherit",
      objectFit: "contain",
      maxWidth: "400px",
    }}
  />
);

const H3Renderer = ({ ...props }) => <h3 {...props} className="mt-8" />;

// New renderers for ordered and unordered lists.
const OlRenderer = ({ children, ...props }: { children: React.ReactNode }) => (
  <ol {...props} className="list-decimal ml-6">
    {children}
  </ol>
);

const UlRenderer = ({ children, ...props }: { children: React.ReactNode }) => (
  <ul {...props} className="list-disc ml-6">
    {children}
  </ul>
);

const LiRenderer = ({ children, ...props }: { children: React.ReactNode }) => (
  <li {...props} className="my-1">
    {children}
  </li>
);

export const MarkdownRenderer = ({
  children,
}: {
  children: string | null | undefined;
  className?: string;
}) => {
  return (
    <Markdown
      // className={cn("markdown-body dark bg-transparent", className)}
      components={{
        a: LinkRenderer,
        img: ImageRenderer,
        h3: H3Renderer,
        // @ts-ignore
        ol: OlRenderer,
        // @ts-ignore
        ul: UlRenderer,
        // @ts-ignore
        li: LiRenderer,
      }}
      remarkPlugins={[remarkGfm]}
    >
      {children}
    </Markdown>
  );
};
